import React, { useEffect, useState } from "react";
import Button from "../../../UI/Buttons/Button";
import { FaArrowLeft } from "react-icons/fa";
import { PiCertificateFill } from "react-icons/pi";
import { StepsContainerStyled } from "../../../../styled/Resume";
import SkillsCard from "../../Tools/SkillsCard";
import { useTheme } from "../../../UI/Theme/ThemeContext";

const SkillsInfo = (props) => {
    const {
        step,
        setStep,
        setStepData,
        skills,
        handleSkillChange,
        handleDeleteSkill,
        handleAddSkill,
        interests,
        handleInterestChange,
        handleDeleteInterests,
        handleAddInterests,
        skillsForwardOrBackward, 
        onSubmitCreate
    } = props;

    const [disableFields, setDisableFields] = useState(true);
    const { themeName } = useTheme();

    useEffect(() => {
        setStepData(prev => ({
            ...prev,
            skillsInfo: skills,
            interestsInfo: interests
        }));
    }, [skills, interests, setStepData]);

    useEffect(() => {
        const hasSkills = skills && skills.length > 0 && skills.every(s => s.trim() !== "");
        const hasInterests = interests && interests.length > 0 && interests.every(i => i.trim() !== "");
        setDisableFields(!(hasSkills || hasInterests)); 
    }, [skills, interests]);

    const handleSkillsClickForward = (e) => {
        if (e) e.preventDefault();
        skillsForwardOrBackward("forward");
        if (!disableFields) {
            setStep(step + 1);
        }
    };




    return (
        <StepsContainerStyled theme={themeName}>
            {skills && <h2>Relevant Skills</h2>}
            {interests && <h2>Hobbies</h2>}

            <SkillsCard
                skills={skills}
                handleSkillChange={handleSkillChange}
                handleDeleteSkill={handleDeleteSkill}
                handleAddSkill={handleAddSkill}
                interests={interests}
                handleInterestChange={handleInterestChange}
                handleDeleteInterests={handleDeleteInterests}
                handleAddInterests={handleAddInterests}
            />

            <div className={step > 1 ? 'btnS' : 'btn'}>
                <Button
                    justifycontent="start"
                    secondaryLight
                    width="100%"
                    clickHandle={()=>setStep((prev)=> prev -1)}
                >
                    <FaArrowLeft />
                    Previous
                </Button>

                {skills && (
                    <div className="nextBtnWrap">
                        <Button
                            justifycontent="flex-end"
                            primary
                            width="100%"
                            clickHandle={handleSkillsClickForward}
                            disabled={disableFields}
                        >
                            Certifications
                            <PiCertificateFill />
                        </Button>
                    </div>
                )}

                {interests && (
                    <div className="nextBtnWrap">
                        <Button
                            primary
                            width="100%"
                            clickHandle={onSubmitCreate}
                            disabled={disableFields}
                        >
                            Build and Preview
                        </Button>
                    </div>
                )}
            </div>
        </StepsContainerStyled>
    );
};

export default SkillsInfo;